<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">부서관리</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
            <el-button type="warning" icon="el-icon-document-copy" @click="saveIdx" v-if="this.selectId != '0'">순서저장</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 테이블 -->
      <div class="talbe-contain" style="display: flex;">
        <div class="table-area" style="margin-right: 50px; width: 30%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridMain"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :headerHeight="0"
                :rowModelType="rowModelType"
                :treeData="true"
                :isServerSideGroup="isServerSideGroup"
                :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
                :getServerSideGroupKey="getServerSideGroupKey"
                :autoGroupColumnDef="autoGroupColumnDef"
                :animateRows="true"
                :rowData="data"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :gridOptions="gridOptions"
                :suppressRowClickSelection="false"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClickedMain"
            />
          </div>
        </div>
        <div class="table-area" style="width: 70%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 42vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClickedSub"
            />
          </div>
          <dept-info ref="deptInfo"  :deptDetail="deptDetail" :parentNm="parentNm" :catLvl="form.catLvl"/>
        </div>
      </div> <!-- table contain -->
    </div>
  </div>


</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import DeptInfo from '@/components/InfoManage/DeptInfo.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "codeMng",
  components: {DeptInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      onReadyParams: [],
      parentNm: "",
      form: {
        deptKey: "",
        deptNm: "",
        deptId: "",
        deptCd: "",
        parentId: "",
        topKey: "",
        deptIdx: "",
        description: "",
      },
      defForm: {
        deptKey: "",
        deptNm: "",
        deptId: "",
        parentId: "",
        deptIdx: "",
        parentNm: "",
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      deptDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      selectLvl : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 71vh; min-height:100px;',
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.onReadyParams = params;
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/deptMng/list"), {
        companyId: this.$store.state.loginInfo.compCd
      }).then(response => {
        this.data = updateData(response.data);
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indidepte if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName: '선택'
          , field:'regYn'
          , width : 15
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "1"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "0"  //false값 지정 defalut-"N" ex) "N", false, "0"
          },
        },
        {headerName:'부서코드', field:'deptCd', headerClass: 'require-column', width:50, editable:false},
        {headerName:'부서명', field:'deptNm', headerClass: 'require-column', width:80, editable:false},
        {headerName:'순서', field:'deptIdx', width:30, editable:true, cellStyle:{ textAlign:'right'}},
        {headerName:'부서코드', field:'deptId', hide:true},
      ];
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      const voRow = params.data //선택된 Row
      this.deptDetail = this.defForm;
      this.parentNm = voRow.menu_nm;
      this.$store.commit('loading')
      this.$http
          .post("/api/deptMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow.menu_id,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow.menu_id;
            this.selectLvl = voRow.menu_lvl;
            this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClickedSub(params) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      const voRow = params.data //선택된 Row
      this.$http
          .post("/api/deptMng/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            deptId: voRow.deptId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.deptDetail = response.data[0];
            }
          }).finally(() => {
      });
    },
    goOpen() {


      // detail 재실행
      this.$store.commit('loading')
      this.$http
          .post("/api/deptMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId:  this.selectId,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    save() {
      const deptInfo = JSON.parse(JSON.stringify(this.$refs.deptInfo.form));

      let maxIdx = 0;
      let idx;

      for (var i = 0; this.subData.length > i ; i++){
        if(this.subData[i].deptIdx > maxIdx) maxIdx = this.subData[i].deptIdx;
      }

      if(deptInfo.deptIdx == ""){
        idx = maxIdx+1;
      } else {
        idx = deptInfo.deptIdx;
      }

      if(!this.gridRequireCheck([this.$refs.gridMain, this.$refs.gridSub ])) return;

      if(this.selectLvl > 5){
        this.$swal({type: 'warning', text: '부서관리는 6단계까지 입니다. 더이상 등록할수 없는 단계입니다.'});
        return false;
      }

      //상세코드 확인
      if(deptInfo.deptNm == ""){
        this.$swal({type: 'warning', text: '부서명은 필수 입력 사항입니다.'});
        return false;
      }

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(deptInfo.deptId == ""){


        //저장 시작
        this.$store.commit('loading')
        this.$http
            .put('/api/deptMng/save',{
              companyId: this.$store.state.loginInfo.compCd,
              parentId: this.selectId,
              deptIdx: this.isEmpty(idx) == '' ? 1 : idx,
              deptNm: deptInfo.deptNm,
              deptKey: deptInfo.deptKey,
              deptCd: "",
              useYn: "Y",
              description: deptInfo.description,
              creatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
              processTime: "",
              deptId: "0",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.onReadyMain(this.onReadyParams);
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            }).finally(() => {
              this.$store.commit('finish')
            });
      }else{

        //수정 시작
        this.$store.commit('loading')
        this.$http
            .put('/api/deptMng/update',{
              companyId: this.$store.state.loginInfo.compCd,
              deptId: deptInfo.deptId,
              deptIdx: this.isEmpty(idx) == '' ? 1 : idx,
              deptNm: deptInfo.deptNm,
              deptKey: deptInfo.deptKey,
              deptCd: deptInfo.deptCd,
              useYn: "Y",
              description: deptInfo.description,
              updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '수정되었습니다.' });
              this.onReadyMain(this.onReadyParams);
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            }).finally(() => {
              this.$store.commit('finish')
            });
      }



    },
    saveIdx() {

      let subData = this.$refs.gridSub.rowData;
      try {
        for(var i=0; subData.length; i++){
          this.$http
              .put('/api/deptMng/update/idx',{
                companyId: this.$store.state.loginInfo.compCd,
                deptId: subData[i].deptId,
                deptIdx: subData[i].deptIdx,
                updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
                processTime: ""
              })
              .then(response => {

              })
              .catch(({ message }) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({ type: "error", text: "오류가 발생했습니다." });
                }
              });
        }
      }catch (e){
        this.$swal({
          type: 'error',
          text: '오류가 발생했습니다.'
        })
      }
      this.$swal({ type: 'success', text: '수정되었습니다.' });
      this.goOpen();

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    deleteRow() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 분류를 체크하세요.' });

      for (var i = 0; chkDatas.length > i ; i++){
        let deptId = parseInt(chkDatas[i].deptId);
        let updatorId = this.$store.state.loginInfo.id;
        let compCd =  this.$store.state.loginInfo.compCd;
        this.$http.delete(_url("/api/deptMng/delete/"+ (compCd) +"/"+ (deptId) + "/" + (updatorId) ), {
          process_time : ""
        }).then(response => {
          this.$swal({ type: 'success', text: '삭제 되었습니다.' });
          this.onReadyMain(this.onReadyParams);
          this.cancel();
          this.goOpen();
        });
      }


    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()

        if(row.length < 1)
          throw '선택된 행이 없습니다.'

        let index = row[0].rowIndex
        this.subData.splice(index, 1)

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try{

        const row = this.gridApi.getSelectedNodes()

        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex

        this.subData.push({
          detailCd: "",
          detailNm: "",
          useYn: "Y",
          orderSeq: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          detailDesc: "",
          parent_id: this.data[0].inner_menu[idx-1].parent_id,
          compCd: this.$store.state.loginInfo.compCd,
        });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel(){
      // deptInfo 초기화
      this.$refs.deptInfo.form = _.clone(this.defForm);
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                  menu_lvl: d.menu_lvl
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>


<style scoped>
.gridbox {
  height: 200px !important;
}
.gridbox .objbox {
  height: 350px !important;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}
.btn-wrap {
  margin-bottom: 20px;
}
.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}
.desc-content .item {
  float: left;
}
.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}
.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}
.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}
.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}
.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}
.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}
.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-right {
  width: 30%;
}
.search-area input {
  position: relative;
}
.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}
.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}
.search-border .td-s-thumb.search-area > input,
.search-border
.td-s-thumb.search-area
> .ip-box
.search-border
.td-s-thumb.search-area
> button {
  float: left;
}
.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}
.remove_text {
  margin-left: 0;
}
.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}
</style>